import React, { FC } from "react"
import styled from "styled-components"
import { theme } from "../../../util/styles/theme"
import { CollapsibleContext } from "../../collapsible/components/CollapsibleContext"

export interface CardHeaderProps {
  className?: string
}

interface ContainerProps {
  isCollapsible?: boolean
}

const Container = styled.div<ContainerProps>`
  cursor: ${({ isCollapsible }) => (isCollapsible ? "pointer" : undefined)};

  display: flex;
  flex-direction: column;
  position: relative;
  padding: ${theme.borderRadius.medium};
  margin: -${theme.borderRadius.medium};

  > *:first-child {
    margin-top: 0;
  }

  > *:last-child {
    margin-bottom: 0;
  }
`

export const CardHeader: FC<CardHeaderProps> = ({ className, children }) => {
  const context = React.useContext(CollapsibleContext)

  return (
    <Container
      className={className}
      onClick={context.onToggleCollapsed}
      isCollapsible={context.isCollapsible}
    >
      {children}
    </Container>
  )
}
